import { Select } from '@octano/global-ui';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useValidations } from '../../../hooks/useValidations';
import { useMaintainerScheduleClassroomLoader } from './MaintainerScheduleClassroomLoader';
import { ScheduleSectionFormData } from './ModalMaintainerSchedulePre';

const prefix = 'sectionsMaintainer.update';

interface Props {}

/**
 * Este componente se encarga de mostrar la lista de salones disponibles en la
 * creación o actualización de una nueva clase de una sección (sections_schedules)
 * El listado de clases viene del loader que lo envuelve
 */
function MaintainerScheduleClassroomSelector(props: Props) {
  const { control } = useFormContext<ScheduleSectionFormData>();
  const { data } = useMaintainerScheduleClassroomLoader();
  const { msgValidations } = useValidations();

  const { t } = useTranslation();
  return (
    <Select
      label={t(`${prefix}.classroom`)}
      name="classroom"
      options={data!.map((classroom) => ({
        value: classroom.id,
        label: classroom.name,
      }))}
      control={control}
      rules={{ required: msgValidations.required }}
      shouldUnregister
    />
  );
}

export default MaintainerScheduleClassroomSelector;
